import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "redPoint"
}
const _hoisted_3 = { class: "pathBtn" }

import { playClickSound } from '@/utils/media';
import { goToRedirectPath, PromotionItem } from '@/view/promotion/supporrtScript';
import { ref, PropType } from 'vue';
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'promotionCardNew',
  props: {
    itemData: {
        type: Object as PropType<PromotionItem>,
        default: () => ({
            name: '',
            unclaimed_count: 0,
            image: '',
            icon: ''
        }),
        required: true
    }
},
  emits: ["openAgentPopup", "openRedEnvelop", "goToHome"],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const props = __props
const isPopping = ref(false)
const emits = __emit
const goToPath = () => {
    goToRedirectPath(isPopping, props.itemData, router, emits, playClickSound)
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card_container", { 'pop-animate': isPopping.value }]),
    onClick: goToPath
  }, [
    _createElementVNode("img", {
      src: props.itemData.image,
      alt: ""
    }, null, 8, _hoisted_1),
    _createVNode(_component_van_row, { class: "bottom_part" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "15",
          class: "text"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t(`activityName.${props.itemData.name}`)), 1),
            (props.itemData.unclaimed_count && props.itemData.unclaimed_count > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.itemData.unclaimed_count), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "9",
          class: "button"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.inprogress')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}
}

})